module.exports = __webpack_public_path__ + "static/media/donbosco10.ba41e841.jpg";